import React, { Fragment } from 'react'

const filtersList = [
	{
		name: 'avatarify',
		videoSrc: '/videos/filters/avaratify.mp4',
		description: `With Avatarify, you are able to create novelty, swap faces and animate the photos `,
	},
	{
		name: 'cartoonify',
		videoSrc: '/videos/filters/cartoonify.mp4',
		description:
			"Whether you want to cartoon yourself, your pet, or an amazing sunset you captured, Cartoonify's photo to cartoon effects have you covered.",
	},
	{
		name: 'babyfy',
		videoSrc: '/videos/filters/babyfy.mp4',
		description: (
			<Fragment>
				Do you want to know what your future baby will look like?{' '}
				<b>10 million people</b> have already managed to do this!
			</Fragment>
		),
	},
	{
		name: 'ageing',
		videoSrc: '/videos/filters/ageing.mp4',
		description:
			"What will you look like when you're old? And what about your friends? Find out with Ageing",
	},
]

const predictionsList = [
	{
		name: 'cartoonify',
		videoSrc: '/videos/filters/cartoonify.mp4',
		description:
			"Whether you want to cartoon yourself, your pet, or an amazing sunset you captured, Cartoonify's photo to cartoon effects have you covered.",
	},
	{
		name: 'child prediction',
		videoSrc: '/videos/filters/babyfy.mp4',
		description: (
			<Fragment>
				Do you want to know what your future baby will look like?{' '}
				<b>10 million people</b> have already managed to do this!
			</Fragment>
		),
	},
	{
		name: 'aging prediction',
		videoSrc: '/videos/filters/ageing.mp4',
		description:
			"What will you look like when you're old? And what about your friends? Find out with Ageing",
	},
]

const cartoonifyList = [
	{
		name: 'cartoonify',
		videoSrc: '/videos/filters/cartoonify.mp4',
		description:
			"Whether you want to cartoon yourself, your pet, or an amazing sunset you captured, Cartoonify's photo to cartoon effects have you covered.",
	},
	{
		name: 'avatarify',
		videoSrc: '/videos/filters/avaratify.mp4',
		isSmall: true,
	},
	{
		name: 'babyfy',
		videoSrc: '/videos/filters/babyfy.mp4',
		isSmall: true,
	},
	{
		name: 'ageing',
		videoSrc: '/videos/filters/ageing.mp4',
		isSmall: true,
	},
]

const zombifyList = [
	{
		name: 'elfy',
		videoSrc: '/videos/filters/elfy.mp4',
		description: 'Elves are powerful, mythical creatures. Which kind are you?',
	},
	{
		name: 'cartoonify',
		videoSrc: '/videos/filters/cartoonify.mp4',
		description:
			"Whether you want to cartoon yourself, your pet, or an amazing sunset you captured, Cartoonify's photo to cartoon effects have you covered.",
	},
	{
		name: 'orc style',
		videoSrc: '/videos/filters/orc.mp4',
		description:
			"Halloween is close! It's time to find out how you would look like an orc with our brand new orc style feature",
	},
	{
		name: 'ageing',
		videoSrc: '/videos/filters/ageing.mp4',
		description:
			"What will you look like when you're old? And what about your friends? Find out with Ageing",
	},
]

export { filtersList, predictionsList, cartoonifyList, zombifyList }
